import { render, staticRenderFns } from "./BasicTextStyleEditor.vue?vue&type=template&id=274e451c&scoped=true"
import script from "./BasicTextStyleEditor.vue?vue&type=script&lang=ts"
export * from "./BasicTextStyleEditor.vue?vue&type=script&lang=ts"
import style0 from "./BasicTextStyleEditor.vue?vue&type=style&index=0&id=274e451c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274e451c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('274e451c')) {
      api.createRecord('274e451c', component.options)
    } else {
      api.reload('274e451c', component.options)
    }
    module.hot.accept("./BasicTextStyleEditor.vue?vue&type=template&id=274e451c&scoped=true", function () {
      api.rerender('274e451c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layout-editor/BasicTextStyleEditor.vue"
export default component.exports